import { XCircleFill } from 'react-bootstrap-icons'
import { useProducts } from '../../../../hooks/useProducts'

import './styles.css'

export function ProductCard({ product }) {
  const { removeProduct } = useProducts()

  let imageUrl = null

  if (product.IMG_CAPA) {
    imageUrl = `${process.env.REACT_APP_IMAGE_URL_API}/${product.IMG_CAPA}`
  } else {
    imageUrl = `${process.env.REACT_APP_IMAGE_URL_API}/no-image.jpg`
  }

  return (
    <article
      className="product-card"
      style={{
        position: 'relative',
      }}
    >
      <button
        onClick={() => removeProduct(product.CODPRODUTO)}
        style={{
          all: 'unset',
          cursor: 'pointer',
          position: 'absolute',
          top: 0,
          right: 0,
          marginRight: '5px',
        }}
      >
        <XCircleFill color="red" />
      </button>

      <div
        id="image"
        style={{
          backgroundImage: `url("${imageUrl}")`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
        }}
      />

      <div>
        <strong>SKU: {product.SKU}</strong>
        <p>{product.DESCRICAO}</p>
      </div>
    </article>
  )
}
